define('modules/page/functions',[
	'app',
	'jquery',
	'backbone',
],
function(app, $, Backbone) {

	return Backbone.View.extend({
		isMobile: false,

		initialize: function(params){
			_.bindAll(this, 'checkDocWidth', 'detectIEVersion');
		},

		checkDocWidth: function(checkAgainst) {
			// this.isMobile = true;
			// console.log($('body').outerWidth());
			if($('body').outerWidth() <= checkAgainst) {
				this.isMobile = true;
			} else {
				this.isMobile = false;
			}
			return this.isMobile;
		},

		detectIEVersion: function () {
		    if (/MSIE (\d+\.\d+);/.test(navigator.userAgent)) { //test for MSIE x.x;
		        var ieversion = new Number(RegExp.$1) // capture x.x portion and store as a number
		        return ieversion;
		    } else {
		        return -1;
		    }
		},

	});

});

